var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyMessageCardsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 105.691,
    viewBox: "0 0 160 105.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1596",
    "data-name": "Rectangle 1596",
    width: 160,
    height: 105.691,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error_message",
    "data-name": "Error message",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4729",
    "data-name": "Group 4729",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M96.884,4.186c.2-.124.329-.212.463-.283a9.022,9.022,0,0,1,1.131-.56c1.5-.518,2.5.22,2.4,1.808A7.144,7.144,0,0,1,98.5,9.841c-.176.173-.377.319-.542.5a4.756,4.756,0,0,0-.359.512,6.5,6.5,0,0,1,.631.3,3.176,3.176,0,0,1,.907.621c.3.375.13.8-.285,1.063a1.02,1.02,0,0,0-.336.31,1.909,1.909,0,0,1-1.765.966,11.383,11.383,0,0,1-2.4-.224,4.994,4.994,0,0,0-1.767-.041,7.956,7.956,0,0,1-1.058.009v-.132L93,13.629c-.848-.707-2.008-.7-2.784-1.478l1.1.5c.023-.039.045-.08.067-.121A3.963,3.963,0,0,1,91,12.2a7.417,7.417,0,0,1-.818-.958,1.324,1.324,0,0,1,.783-2.156,17.63,17.63,0,0,1,1.74-.339c-.054-.207-.109-.4-.16-.6a8.52,8.52,0,0,1,.1-5.19A4.4,4.4,0,0,1,93.52,1.6a1.219,1.219,0,0,1,1.908-.038A11.166,11.166,0,0,1,96.6,3.346a4.574,4.574,0,0,1,.283.84",
    transform: "translate(46.207 0.576)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M159.1,64.83c-5.383,24.884-57.469,39.625-100.456,30.327S-4.53,57.61.854,32.725,45.5-7.478,95.757,3.732c50.206,11.2,68.728,36.214,63.345,61.1",
    transform: "translate(0 0)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M17.492,77.779V91.087s.1,5.3,8.1,2.6l9.931-4.146h70.47a18.578,18.578,0,0,0,18.578-18.578V39.724a18.577,18.577,0,0,0-18.578-18.578H35.926A18.577,18.577,0,0,0,17.348,39.724Z",
    transform: "translate(8.918 10.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M17.492,77.539V90.877s.1,5.314,8.119,2.609l9.954-4.156H106.2a18.62,18.62,0,0,0,18.62-18.62V39.4a18.62,18.62,0,0,0-18.62-18.62H35.967A18.619,18.619,0,0,0,17.348,39.4Z",
    transform: "translate(8.918 10.681)",
    fill: "none",
    stroke: "#ccc",
    strokeWidth: 1,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M9.332,35.96a53.507,53.507,0,0,1,0-10.63",
    transform: "translate(4.665 13.022)",
    fill: "none",
    stroke: "#ccc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M9.244,32.773C11.777,22.285,21.816,14.8,31.488,11.444c13.335-4.624,29.133-4.63,42.187.812,2.769,1.155,5.531,2.616,7.371,4.986,3.119,4.015,1.213,8.326-3.869,7.99-5.405-.359-24.012-6.187-17.6-14.491,1.967-2.547,5.139-4.324,8.041-5.607,0,0,23.194-11.792,57.987,3.092",
    transform: "translate(4.752 0.36)",
    fill: "none",
    stroke: "#ccc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5044",
    "data-name": "Group 5044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M75.633,11.094a13.8,13.8,0,0,0-13.642,13.96,13.639,13.639,0,1,0,27.269,0,13.8,13.8,0,0,0-13.627-13.96m3.316,18.82a3.687,3.687,0,0,1-3.316,1.726,3.736,3.736,0,0,1-3.361-1.6,8.628,8.628,0,0,1-1.06-4.769,9.1,9.1,0,0,1,1.151-5.042A4.156,4.156,0,0,1,79.04,20.1a9.439,9.439,0,0,1,1.014,4.875,9.239,9.239,0,0,1-1.105,4.936",
    transform: "translate(31.869 5.703)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M75.91,17.594a4.158,4.158,0,0,0-6.679.121,9.1,9.1,0,0,0-1.151,5.042,8.627,8.627,0,0,0,1.061,4.769,3.736,3.736,0,0,0,3.361,1.6,3.686,3.686,0,0,0,3.314-1.726,9.224,9.224,0,0,0,1.107-4.936,9.454,9.454,0,0,0-1.014-4.875m-2.1,8.328c-.244.742-.666,1.12-1.3,1.12-.577,0-1-.363-1.257-1.09a9.891,9.891,0,0,1-.4-3.255,11.8,11.8,0,0,1,.379-3.482c.257-.772.683-1.151,1.273-1.151.619,0,1.043.363,1.287,1.12a11.644,11.644,0,0,1,.362,3.361,12.454,12.454,0,0,1-.347,3.376",
    transform: "translate(35 8.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M72.85,18.474a11.644,11.644,0,0,1,.362,3.361,12.381,12.381,0,0,1-.348,3.376c-.242.742-.665,1.12-1.3,1.12-.575,0-1-.363-1.255-1.09a9.891,9.891,0,0,1-.4-3.255A11.8,11.8,0,0,1,70.29,18.5c.257-.772.681-1.151,1.272-1.151.621,0,1.045.363,1.288,1.12",
    transform: "translate(35.941 8.922)",
    fill: "#407bff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMessageCardsIcon);
export default __webpack_public_path__ + "static/media/empty-message-cards-icon.50efd38d4989b56dcccd4e32e46c0228.svg";
export { ForwardRef as ReactComponent };